const Schools = () => (
  <section id="schools" style={{ background: "#E2F7F3" }}>
    <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "104px 24px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(480px, 100%), 1fr))", gap: "48px", alignItems: "center" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
        <span style={{ fontWeight: "700", color: "#145E55", fontSize: "16px" }}>
          للمدارس والمؤسّسات
        </span>
        <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(32px, 3.8vw, 48px)", lineHeight: "1.2" }}>
          منصّة تتكيّف مع برنامج مدرستك
        </h2>
        <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#2E4A47" }}>
          بفضل نظام إدارة المحتوى المرن (CMS)، تضيف المدرسة أو الوزارة دروسها ولغاتها وقيمها المحلّيّة دون أيّ برمجة. خطوة شريك لمدارس تونسيّة ولشبكة تعتمد نظام كامبريدج.
        </p>
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          <a href="#contact" style={{ display: "inline-flex", alignItems: "center", minHeight: "54px", padding: "0 24px", borderRadius: "18px", background: "#0B1240", color: "#FFFFFF", fontWeight: "800", textDecoration: "none" }}>
            اطلب عرضًا لمدرستك
          </a>
          <a href="#contact" style={{ display: "inline-flex", alignItems: "center", minHeight: "54px", padding: "0 24px", borderRadius: "18px", border: "2px solid #0B1240", color: "#0B1240", fontWeight: "800", textDecoration: "none" }}>
            حمّل الكتيّب التعريفي
          </a>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(240px, 100%), 1fr))", gap: "14px" }}>
        <div style={{ background: "#FFFFFF", borderRadius: "22px", padding: "22px", display: "flex", flexDirection: "column", gap: "6px" }}>
          <strong style={{ fontSize: "18px" }}>
            محتوى قابل للتخصيص
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            وحدات تُضاف حسب حاجة المؤسّسة.
          </span>
        </div>
        <div style={{ background: "#FFFFFF", borderRadius: "22px", padding: "22px", display: "flex", flexDirection: "column", gap: "6px" }}>
          <strong style={{ fontSize: "18px" }}>
            متابعة القسم
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            [للتأكيد] لوحة متابعة للمعلّم حسب القسم والتلميذ.
          </span>
        </div>
        <div style={{ background: "#FFFFFF", borderRadius: "22px", padding: "22px", display: "flex", flexDirection: "column", gap: "6px" }}>
          <strong style={{ fontSize: "18px" }}>
            متعدّد اللغات
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            العربيّة والفرنسيّة والإنجليزيّة.
          </span>
        </div>
        <div style={{ background: "#FFFFFF", borderRadius: "22px", padding: "22px", display: "flex", flexDirection: "column", gap: "6px" }}>
          <strong style={{ fontSize: "18px" }}>
            تكوين ومرافقة
          </strong>
          <span style={{ fontSize: "15px", color: "#3A4270" }}>
            نرافق المعلّمين في إدماج التطبيق في القسم.
          </span>
        </div>
      </div>
    </div>
  </section>
);

export default Schools;
